var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inquiry-admin"},[(_vm.step == 3)?_c('div',[_c('SubmitCompleted')],1):(_vm.step == 2)?_c('div',[_c('ViewForm',{attrs:{"inquiry":_vm.inquiry},on:{"change":_vm.handleStep}})],1):_c('div',[_c('SubmitForm',{attrs:{"oldInquiry":_vm.inquiry},on:{"change":_vm.handleConfirm}})],1)]),_c('MetaTags')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }